export const RIMS_LOCAL_STG_CONSTANTS = {
  LOGIN_TOKEN: "LOGIN_TOKEN",
  USER_INFO: "USER_INFO",
  MENU_AUTH_LIST: "MENU_AUTH_LIST",
  DATA_AUTH_LIST: "DATA_AUTH_LIST",
  SESSION_TIME_OUT: "SESSION_TIME_OUT",
  PRIVILEGES: "PRIVILEGES",
  DATEFORMAT: "DATEFORMAT",
  EMAIL: "EMAIL",
  DISABLE_BACK_PREVIOUS: "DISABLE_BACK_PREVIOUS",
  GLOBAL_LOADING: "GLOBAL_LOADING",
  SPECIFY_AUTH_LIST: "SPECIFY_AUTH_LIST"
};

export const RIMS_COOKIE_CONSTANTS = {
  USER_TENANT_ID: "USER_TENANT_ID",
  LOGIN_TOKEN: "ACCESS_TOKEN",
  USER_ID: "USER_ID",
  URL_DOMAIN: "URL_DOMAIN",
  DOMAIN: "DOMAIN",
  USER_NAME: "USER_NAME",
  USER_EMAIL: "USER_EMAIL",
  USER_PRIVILEGES: "USER_PRIVILEGES",
  USER_INFO: "USER_INFO"
};

export const LANGUAGEMAP: { [key: string]: any } = {
  mui: {
    en: "enUS",
    zh: "zhCN",
    jp: "jaJP",
  },
};

export const enum ModeEnum {
    READ = 'read',
    UPDATE = 'update',
    CREATE = 'create'
}

export const pathAuthMap = [
  { path: '/lcm', permission: 'View_LCM' },
  { path: 'view-obligation', permission: 'View_LCM_OBG' },
  { path: '/obligations', permission: 'View_LCM_OBG' },
  { path: 'view-commitment', permission: 'View_LCM_CMT' },
  { path: '/commitments', permission: 'View_LCM_CMT' },
  { path: 'view-local-update', permission: 'View_LCM_LU' },
  { path: '/local-updates', permission: 'View_LCM_LU' },
  { path: 'add-obligation', permission: 'Add_LCM_OBG' },
  { path: 'add-commitment', permission: 'Add_LCM_CMT' },
  { path: 'add-local-update', permission: 'Add_LCM_LU' },
  { path: 'edit-obligation', permission: 'Edit_LCM_OBG' },
  { path: 'edit-commitment', permission: 'Edit_LCM_CMT' },
  { path: 'edit-local-update', permission: 'Edit_LCM_LU' },
]

export const includeFields: string[] = [
  "lifecyclestages",
  "recordid",
  "nonformfields",
  "version"
];
